<template>
  <ValidationProvider :rules="rules" :vid="vid" v-slot="validationContext">
    <b-form-group>
      <template v-slot:label>
        <span v-html="formattedLabel"></span>
      </template>

      <b-input-group
        class="mb-3"
        :invalid-feedback="message(validationContext)"
      >
        <b-input-group-prepend v-if="prepend">
          <b-button
            variant="outline-info"
            class="help__prepend"
            v-html="prepend"
          ></b-button>
        </b-input-group-prepend>

        <b-form-input
          v-model="model"
          :type="type"
          :name="name"
          :placeholder="placeholder"
          @keydown="onKeyDown"
          v-bind="$attrs"
          :disabled="disabled"
          :state="getValidationState(validationContext)"
          @input="$emit('input', model)"
        >
        </b-form-input>

        <b-input-group-append>
          <slot name="help"></slot>
          <b-button
            variant="outline-info"
            class="help"
            v-if="unit"
            v-html="unit"
          ></b-button>
        </b-input-group-append>
        <b-form-invalid-feedback>
          {{ message(validationContext) }}
        </b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>
  </ValidationProvider>
</template>
<script>
import { BFormInput } from "bootstrap-vue";

export default {
  components: {
    BFormInput,
  },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    unit: {
      type: String,
      default: null,
    },
    vid: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    prepend: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Object],
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    invalid: {
      type: String,
      default: "This field is required",
    },
    value: {},
  },
  data() {
    return {
      model: "",
    };
  },
  computed: {
    formattedLabel() {
      if (!this.rules) return this.label;
      if (this.rules.indexOf("required") != -1)
        return this.label + " <span style='color:red'>*</span>";
      return this.label;
    },
  },
  watch: {
    value(val) {
      this.model = val;
    },
  },
  methods: {
    onKeyDown(e) {
      if (this.type == "number") {
        var invalidChars = ["-", "+", "e"];
        if (invalidChars.includes(e.key)) {
          e.preventDefault();
        }
        // let rules = [""]
      }
    },
    message(validationContext) {
      return validationContext.errors[0];
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
  mounted() {
    this.model = this.value;
  },
};
</script>
